import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix default marker icon issue in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const UserMap = ({ userLocations }) => {
  return (
    <MapContainer center={[17.4500, 78.3880]} zoom={10} style={{ height: "500px", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {userLocations.filter((user) => user.latitude !== null && user.longitude !== null).map((user, index) => (
            
        <Marker key={index} position={[user.latitude, user.longitude]}>
          <Popup>
                      {/* User: {user.name} <br /> Location: {user.lat}, {user.lng} */}
                      {/* {user.firstname} */}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default UserMap;
